<section class="invite-member">
  <header class="invite-member__header">
    <h3 class="invite-member__title">{{ 'translations.invitations.quick.title' | transloco }}</h3>
    <button
      type="button"
      class="invite-member__close"
      [attr.aria-label]="'translations.global.ariaLabels.close' | transloco"
      (click)="onClose()"
    >
      <ptl-icon [icon]="LucideX" size="xs"></ptl-icon>
    </button>
  </header>

  <p class="invite-member__subtitle">{{ 'translations.invitations.quick.subtitle' | transloco }}</p>

  <div class="invite-member__notice">
    <ptl-icon class="invite-member__notice-icon" [icon]="LucideTriangleAlert" size="xs"></ptl-icon>
    <div class="invite-member__notice-text">
      <strong>{{ 'translations.invitations.quick.notice.lead' | transloco }}</strong>
      {{ 'translations.invitations.quick.notice.body' | transloco }}
      <button type="button" class="invite-member__notice-link" (click)="onOpenMemberInvites()">
        {{ 'translations.invitations.quick.notice.link' | transloco }}
      </button>
    </div>
  </div>

  <div class="invite-member__form">
    <div class="invite-member__field invite-member__field--email">
      <label class="invite-member__label">{{ 'translations.invitations.quick.field.email' | transloco }}</label>
      <ptl-sg-input
        size="s"
        type="email"
        [formControl]="emailControl"
        [placeholder]="'translations.invitations.quick.placeholder.email' | transloco"
      ></ptl-sg-input>
      @if (showEmailError && emailControl.invalid) {
        <span class="invite-member__error">
          {{ 'translations.global.input.error.enterEmail' | transloco }}
        </span>
      }
    </div>

    <div class="invite-member__right-side">
      <div class="invite-member__field invite-member__field--role">
        <label class="invite-member__label">{{ 'translations.invitations.quick.field.role' | transloco }}</label>
        <ptl-select
          size="s"
          [formControl]="roleControl"
          [options]="roleOptions"
          [placeholder]="'translations.invitations.quick.placeholder.role' | transloco"
        ></ptl-select>
      </div>
      <div class="invite-member__actions">
        <ptl-button
          type="primary"
          size="sm"
          [text]="'translations.invitations.quick.button.sendInvite' | transloco"
          [disabled]="invitationInProgress"
          (clicked)="onSendInvite()"
        ></ptl-button>
        <ptl-button
          type="secondary-neutral"
          size="sm"
          [text]="'translations.global.button.cancel' | transloco"
          [disabled]="invitationInProgress"
          (clicked)="onCancel()"
        ></ptl-button>
      </div>
    </div>
  </div>
</section>
